import { Odds } from '@frontend/sports/odds/feature';
import { Decimal } from 'decimal.js';

import { BetslipType } from '../../../../core/betslip-type';
import { BetslipPick } from '../../../../core/picks/betslip-pick';
import { CriteriaType, IRewardToken } from '../../reward-tokens.model';

export interface TokenPicksValidity {
    isValid: boolean;
    validPicksIds: string[];
}

export function picksValidity(isValid: boolean, picks: BetslipPick[]): TokenPicksValidity {
    return {
        isValid,
        validPicksIds: picks.map((pick) => pick.id.toString()),
    };
}

export type TokenValidity = boolean | TokenPicksValidity;
export abstract class CriteriaValidatorBase<T extends IRewardToken, C extends CriteriaType, S> {
    type: C;
    abstract isValid(token: T, state: S): TokenValidity;
}

//Please consider extending the interface instead of adding properties to it
export interface TokenValidationInput {
    selectedPicks: BetslipPick[];
    allPicks: BetslipPick[];
    selectedType: BetslipType | null;
    stake: Decimal;
    hasEachWay: boolean;
    teaserTotalOdds: Odds | undefined;
}
export abstract class TokensCriteriaValidatorBase<T extends IRewardToken, C extends CriteriaType> extends CriteriaValidatorBase<
    T,
    C,
    TokenValidationInput
> {
    override type: C;
    abstract override isValid(token: T, state: TokenValidationInput): TokenValidity;
}
